"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.newILendingPoolAddressesProviderV2 = exports.ABI = void 0;
exports.ABI = [
    {
        inputs: [],
        name: "getLendingPool",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
];
function newILendingPoolAddressesProviderV2(web3, address) {
    return new web3.eth.Contract(exports.ABI, address);
}
exports.newILendingPoolAddressesProviderV2 = newILendingPoolAddressesProviderV2;
//# sourceMappingURL=ILendingPoolAddressesProviderV2.js.map